import Vue from 'vue';
import {Component, Emit, Prop, Watch} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {DocumentViewModel} from './document.viewmodel';
import {
  DOCUMENT_GET_ATTACHMENT_TYPES,
  DOCUMENT_MODULE_NAMESPACE,
  DOCUMENT_SET_DOCUMENT
} from '../../../../store/document';
import {IDocument} from '../../../../models/documents/document';
import {
  BLOCK_MODULE_NAMESPACE,
  BLOCK_GET_BLOCKS_BYQUERY,
  BLOCK_GET_BLOCK,
  BLOCK_GET_BLOCKS_BY_ID, BLOCK_GET_BLOCKS
} from '../../../../store/block';
import {APARTMENT_MODULE_NAMESPACE, APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE} from '../../../../store/apartment';
import {SEARCH_MODULE_NAMESPACE, SEARCH_AUTOCOMPLETE, SEARCH_REQUEST_BYID} from '../../../../store/search';
import {SearchEntities, CrudStatus, UserTemplate} from '../../../../common/enums';
import {IBlockParameter} from "../../../../models/block";
import { TICKET_GET_EQUIPMENT, TICKET_MODULE_NAMESPACE } from '../../../../store/ticket';
import { MaintenanceService, TicketService } from '../../../../services';
import { USER_MODULE_NAMESPACE } from '../../../../store/user/user-types.store';
import { SERIVCEBOOK_MODULE_NAMESPACE } from '../../../../store/service-book';
import { IServiceBookDetails } from '../../../../store/service-book/service-book-state.store';
import { IUserDetails } from '../../../../models/user'
import { PROFILE_GET_ALL_ENTITY_ROLES, PROFILE_MODULE_NAMESPACE } from '../../../../store/profile/profile-types.store';


const DocumentStore = namespace(DOCUMENT_MODULE_NAMESPACE)
const BlockStore = namespace(BLOCK_MODULE_NAMESPACE)
const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)
const UserStore = namespace(USER_MODULE_NAMESPACE)
const ServiceBookStore = namespace(SERIVCEBOOK_MODULE_NAMESPACE)
const ProfileStore= namespace(PROFILE_MODULE_NAMESPACE)

@Component
class DocumentModalVertical extends DocumentViewModel {

  @Prop({ default: false, type: [Boolean] })
  isTicketChat: boolean;

  @Prop({ default: null, type: [Object] })
  equipment: any;

  dtBlocks: any[]
  dtApartments: any[]
  dtEquipments: any[]
  dtEntities: any[]
  dtRules: {
    typesRules?: any,
    types2Rules?: any,
    attachmentRules?: any,
    blockRules?: any,
    apartmentRules?: any
  }
  dtTypesLevel1?: any[]
  dtTypesLevel2?: any[]
  dtAttributesLvl1?: any[]
  dtAttributesLvl2?: any[]
  isLoading:boolean
  TicketService:TicketService
  MaintenanceService:MaintenanceService
  dtRoles: any[]
  rolesLoading:boolean

  constructor() {
    super()
    this.dtBlocks = null
    this.dtApartments = []
    this.dtEquipments = []
    this.dtEntities = []
    this.dtRules = {}
    this.dtTypesLevel2 = []
    this.dtTypesLevel1 = []
    this.dtAttributesLvl1 = []
    this.dtAttributesLvl2 = []
    this.isLoading = false
    this.TicketService = new TicketService()
    this.MaintenanceService = new MaintenanceService()
    this.dtRoles = []
    this.rolesLoading = false

  }

  @Watch('shareWithAllBlocks')
  handleShareWithAllBlocks(val:boolean)
  {
    //console.log(val)
    if(val)
    {
      this.fkBlocks = []
      this.apartments = []
      this.fkEquipment = []
      this.shareWithBlockOwners = false
      this.shareWithBlockTenants = false
      this.shareWithApartmentOwners = false
      this.shareWithApartmentTenants = false
    }
  }

  get isDocumentRoute()
  {
    return this.$route.name === 'document_categories' || this.$route.name === 'document_attachment'
  }


  @ProfileStore.Action(PROFILE_GET_ALL_ENTITY_ROLES)
  storeGetAllEntityRoles: () => Promise<any>


  @ServiceBookStore.Getter currentServiceBook:IServiceBookDetails


  @TicketStore.Action(TICKET_GET_EQUIPMENT)
  storeGetEquipments: (params: any) => Promise<any>;

  @UserStore.Getter modules: object

  @DocumentStore.Getter document: IDocument
  @DocumentStore.Getter documentTypes: any[]
  @DocumentStore.Getter documentCrudActionStatus: CrudStatus
  @BlockStore.Getter blocks: any[]

  @BlockStore.Action(BLOCK_GET_BLOCKS_BYQUERY)
  storeGetBlocksByQuery: (query: string) => Promise<any>

  @BlockStore.Action(BLOCK_GET_BLOCK)
  storeGetBlockBy: (id: number) => Promise<any>

  @BlockStore.Action(BLOCK_GET_BLOCKS)
  storeGetBlocks: (payload: { param: IBlockParameter, merge?: boolean }) => Promise<any>;

  @ApartmentStore.Action(APARTMENT_GET_APPARTMENTS_AUTOCOMPLETE)
  storeGetApartmentsAutocomplete: (payload?: any) => Promise<any>

  @SearchStore.Action(SEARCH_AUTOCOMPLETE)
  storeGetEntitySearch: (
    payload: { entity?: SearchEntities | SearchEntities[], query?: string, limit?: number, apartment?: number[], block?: number[] }
  ) => Promise<any>;

  @SearchStore.Action(SEARCH_REQUEST_BYID)
  storeGetEntityById: (entityId: number) => Promise<any>

  @BlockStore.Action(BLOCK_GET_BLOCKS_BY_ID)
  storeGetBlockById: (id: string) => Promise<any>

  @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT)
  storeSetDocumentByValue: (payload?: IDocument) => void

  @DocumentStore.Action(DOCUMENT_GET_ATTACHMENT_TYPES)
  storeGetAttachmentTypes: (id?: number) => Promise<any>
  @UserStore.Getter userInfo: IUserDetails

  get lblSetting() {
    return {
      ...require('@/locales/document').default,
      ...require('@/locales/block').default,
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/agency-management').default
    }
  }

  get coTypes() {
    if (this.isTicketChat) return this.coTypes1
    return this.documentTypes
  }

  get coTypes1() {
    return this.dtTypesLevel1 || []
  }

  get coTypes2() {
    return this.dtTypesLevel2 || []
  }

  get coAttributes() {
    return this.dtAttributesLvl1.concat(this.dtAttributesLvl2)
  }

  get coBlocks() {
    return (this.dtBlocks || this.blocks)
  }

  set coBlocks(value: any[]) {
    this.dtBlocks = value
  }

  get coApartments() {
    return this.dtApartments
  }

  set coApartments(value: any[]) {
    this.dtApartments = value.filter(item => !!item)
  }

  get coEntities() {
    return this.dtEntities
  }

  set coEntities(value) {
    this.dtEntities = value.map(entity => ({value: entity.id, text: entity.fullname}))
  }

  get isUpdateAction(): boolean {
    return this.documentCrudActionStatus === CrudStatus.Update
  }

  get equipmentRules()
  {
    return []
  }

  get coEquipments()
  {
    return this.dtEquipments
  }

  get isServiceBook():boolean {
    return this.$route.path.includes('service-book')
  }
  get isServiceBookUser():boolean {
    return this.userInfo.template !== UserTemplate.default
  }

  getRoles() {
    // === get roles
    this.rolesLoading = true
    this.storeGetAllEntityRoles()
    .then(response=>{
      console.log('roles ******************* :', response)
      if(response.all) {
        this.dtRoles = response.all.map((item:any)=>({...item, text:item.name}))
      }
    })
    .catch(err=> console.log('error getting entity roles'))
    .finally(()=>{
      this.rolesLoading = false
    })
  }

  mounted() {

    // === service book
    if(this.isServiceBook)
    {
      this.fkBlocks = [this.currentServiceBook.apartment.fk_apartment_block]
      this.apartments = [this.currentServiceBook.apartment.id]
    }


    this.getRoles()


    /**
     * @description implement rules
     */
    this.dtRules = {
      typesRules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: "catégorie"})
      ],
      types2Rules: [
        v => !!v || this.$t(this.lblSetting.emptyRequired, {type: "sous-catégorie"})
      ],
      blockRules: [
        v => (v && v.length > 0) || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.block)})
      ],
      apartmentRules: [
        v => (v && v.length > 0) || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.apartment)})
      ]
    }


    if (this.isUpdateAction) {
      if (this.document.entities && this.document.entities.length)
      {
        Promise.all(this.document.entities.map(entityId => this.storeGetEntityById(entityId)))
          .then(entities => {
            this.coEntities = entities.map(entity => ({
              ...entity,
              fullname: `${entity.firstname} ${entity.lastname}`.trim()
            }))
          })
      }
      this.handleGetTypesLevel2()
      //this.handleFetchEquipments()
      //console.log(this.document)
    } else {
      // === AddDocToEquipment
      if(this.equipment)
      {
        // === add equipment to store IDocument
        this.storeSetDocumentByValue({equipments:[this.equipment.id]})
        const {block} = this.equipment
        if(block)
        {
          console.log('preselect Block ',block)
          this.fkBlocks = []
          this.fkBlocks = [block.id]
          //this.handleFetchApartments()
          //this.handleFetchEquipments()
          this.handleBlockChange()
        }
      }
    }

    /**
     * @description load selects options depending on model values
     */

     if (this.document.blocks && this.document.blocks.length) {
        Promise.all(this.document.blocks.map(blockId => this.storeGetBlockById(blockId.toString())))
          .then(blocks => {
            this.coBlocks = blocks
            this.handleBlockChange()
          })
      }

    this.$nextTick(() => {
      this.storeGetBlocks({param: {}, merge: false})
    })
    this.handleGetTypesLevel1()


  }

  handleSearchChange(newVal: string) {
    if (newVal && newVal.length > 2) {
      this.storeGetBlocksByQuery(newVal)
        .then(response => {
          this.coBlocks = response
        })
        .catch(err => console.log('error fetching blocks options', err))
    }
  }

  @Emit("ChangeBlock")
  handleBlockChange(query?: any) {
    //if(!query) return
    this.handleFetchApartments(query)
    //this.handleFetchEquipments()
    //console.log(query)
  }

  @Emit("ChangeApartment")
  handleApartmentChange(query?: any) {
    //if(!query) return
    //this.handleFetchEquipments()
    //console.log(query)
  }

  handleChangeEquipment(val)
  {
    console.log('handleChangeEquipment : ', val)
  }

  /* handleGetEquipments()
  {
    console.log('handleGetEquipments ...')
  } */

  canAssociateEquipment()
  {
    return this.modules['block_equipment'] && this.modules['block_equipment'] === true
  }

  showEquipmentSelector()
  {
    return this.canAssociateEquipment() && this.fkBlocks && this.fkBlocks.length>0
    /* return this.canAssociateEquipment() && this.$route.name!='block_maintenance_details' && this.fkBlocks && this.fkBlocks.length>0 */
  }

  getEquipmentByParams(resetEqp = true, key = null) {
    let params: any = {
      $limit: 50,
      block: this.fkBlocks
    }

    if(this.isServiceBook)
    {
      params.apartment = this.apartments
    }

    /* if (this.TicketApartments)
      params.apartment = this.TicketApartments
    if (this.FKTicketCharacterProblem)
      params.char1 = this.FKTicketCharacterProblem
    if (this.FKTicketCharacterProblem2)
      params.char2 = this.FKTicketCharacterProblem2
    if (resetEqp) {
      this.FKTicketEquipment = []
      this.dtEquipments = []
    } */

    /* if(this.apartments)
    {
      params.apartment = this.apartments
    } */

    if (key) {
      params.q = key
    }
    //if (this.$route.meta.select_ticket_equipment) {
      //getEquipments(params)
      //return await this.TicketService.getEquipments(params) //this.storeGetEquipments(params)
    //}
    return this.storeGetEquipments(params)
  }

  handleFetchEquipments()
  {
    let params: any = {
      $limit: 50,
      block:this.fkBlocks
    }
    if(this.isServiceBook)
    {
      params.apartment = this.apartments
    }
    return this.storeGetEquipments(params).then((response:any)=>{
      this.dtEquipments = response.data
      if(this.document.equipments && this.document.equipments.length)
      {
        Promise.all(this.document.equipments.map(equipmentId=> this.MaintenanceService.getEquipment(equipmentId.toString()))).then(equipments=>{
          equipments.forEach(equipment=>this.dtEquipments.push(equipment))
        })
      }
    })
  }

  async handleGetEquipments(key: string) {
    return this.getEquipmentByParams(false, key)
      .then(res => {
        this.dtEquipments = res.data
      })
      .catch(error => console.log(error))
  }

  handleFetchApartments(query: string = '') {
    if (this.document.blocks && this.document.blocks.length)
    {
      this.isLoading = true
      this.storeGetApartmentsAutocomplete({blockId: `${this.document.blocks.join()}`})
        .then(apartments => {
          this.coApartments = apartments.filter(apartment => !!apartment)
          // === AddDocToEquipment
          if(this.equipment && this.equipment.apartment)
          {
            const {apartment} = this.equipment
            if(apartment)
            {
              this.apartments = []
              this.apartments = [apartment.id]
            }
          }

          this.handleFetchEquipments().then(d=>{
            this.isLoading = false
          }).catch(err=>{
            this.isLoading = false
          }).finally(()=>{
            this.isLoading = false
          })
        }).catch(err=>{
          this.isLoading = false
        }).finally(()=>{
          this.isLoading = false
        })
    }
  }

  handleGetEntities(query: string) {
    if (!query) return
    this.storeGetEntitySearch({query})
      .then(res => {
        this.coEntities = res
      })
      .catch(err => console.log('catched error=', err))
  }

  handleGetEntityAutocomplete(newVal: string, cb, typeSearchEntity: SearchEntities) {
    if (newVal && newVal.length > 2) {
      this.storeGetEntitySearch({entity: typeSearchEntity, query: newVal})
        .then(res => {
          cb((res || []).map(x => ({value: x.id, text: `${x.firstname} ${x.lastname}`, ...x})))
        })
        .catch(error => console.log(error))
    }
  }

  handleGetApartmentAutocomplete(newVal: string, cb?) {
    if (newVal && newVal.length > 2) {
      if (this.document.blocks && this.document.blocks.length)
        this.storeGetApartmentsAutocomplete({blockId: `${this.document.blocks.join()}`, key: newVal})
          .then(res => {
            cb((res || []).map(x => ({value: x.id, text: x.apartment_number, ...x})))
          })
          .catch(error => console.log(error))
    }
  }

  handleGetBlockAutocomplete(newVal: string, cb) {
    if (newVal && newVal.length > 2) {
      this.storeGetBlocksByQuery(newVal)
        .then(res => {
          cb((res || []).map(x => ({value: x.id, text: x.name, ...x})))
        })
        .catch(error => console.log(error))
    }
  }

  handleGetTypesLevel2() {
    if (!this.type) return []
    else if (this.$route.meta['media_type_level2_allowed'] || this.$route.meta['media_attribute_allowed']) {
      this.isLoading = true
      this.storeGetAttachmentTypes(this.type)
        .then(res => {
          this.dtTypesLevel2 = this.isUpdateAction ? res.level_2 : res.level_2.filter(level2 => level2.enabled === true)
          if (res.level_2.length && this.$route.meta['media_type_level2_allowed']) {
            if (!this.typeLvl2 || !res.level_2.find(x => x.id === this.typeLvl2))
              this.typeLvl2 = res.level_2[0].id
            this.handleGetAttributesLevel2()
          }
          //if (res.attributes.length && this.$route.meta['media_attribute_allowed']) {
          if (this.$route.meta['media_attribute_allowed']) {
            this.dtAttributesLvl1 = res.attributes
          }
        }).finally(()=>{
          this.isLoading = false
        })
    }
  }

  handleGetTypesLevel1() {
    //this.isLoading = true
    this.storeGetAttachmentTypes()
      .then(res => {
        this.dtTypesLevel1 = res
        if(this.$route.params.id && this.$route.name === 'document_attachment')
        {
          let preSelectedDocType = res.find(dt => dt.id === parseInt(this.$route.params.id))
          this.type = preSelectedDocType.id
          this.handleGetTypesLevel2()
        }
      }).finally(()=>{
        //this.isLoading = false
      })
  }

  handleGetAttributesLevel2() {
    if (!this.typeLvl2) return
    else if (this.$route.meta['media_attribute_allowed']) {
      this.storeGetAttachmentTypes(this.typeLvl2)
        .then(res => {
          console.log(res)
          this.dtAttributesLvl2 = res.attributes
        })
    }
  }
}

export default DocumentModalVertical



// WEBPACK FOOTER //
// ./src/containers/documents/components/document-modal-vertical/index.ts